<template>
  <div style="width:220px;">
    <div v-if="user.user_id">
      <v-row class="mt-2 px-2">
        <!-- <v-col cols="12" md="2" v-if="!isMobile()">
          <v-icon class="green--text">mdi-account</v-icon></v-col
        > -->
        <v-col cols="12" md="12" xs="12"
          ><h2>Ihr Account</h2>

          <ul>
            <li>
              <b
                >{{ user.user_vp_name }}, {{ user.user_vp_vorname }}

                <span v-if="user.user_vn_name">
                  <br />Vertragsnehmer: {{ user.user_vn_name }},
                  {{ user.user_vn_vorname }}
                </span></b
              >
            </li>

            <li v-if="user.user_vers_nummer">
              Versicherungs-Nr.:
              <b>{{ user.user_vers_nummer }}</b>
            </li>
            <li>{{ tarif.un_name }} {{ tarif.tarif_title }}</li>
            <li v-if="user.user_status == 1">
              <b class="green--text"
                >Ihr <b>Vertragsschutz</b> wurde <b>freigeschaltet</b></b
              >
            </li>

            <li v-if="user.user_status != 1">
              <span class="orange--text"
                >Ihr <b>Vertragsschutz</b> wird nach der Policierung Ihres
                Vertrages freigeschaltet.</span
              >
            </li>
            <li><a href="/vertragsschutz">alle Funktionen</a></li>
          </ul>
        </v-col>
      </v-row>

      <v-row class="mt-2 px-2" v-if="tarif.showCheck">
        <v-col cols="12" md="2" v-if="!isMobile()">
          <v-icon class="red--text">fingerprint</v-icon></v-col
        >
        <v-col cols="12" md="10" xs="12"
          ><h4>Ihr Vertrag im Detail</h4>
          Leistungsdetails<br />
          <router-link to="/vertragscheck">
            <a
              >{{ tarif.un_name }}
              {{ tarif.tarif_title }}
              ...abrufen...</a
            ></router-link
          >
        </v-col>
      </v-row>

      <v-row class="mt-2 px-2">
        <v-col cols="12" md="2" v-if="!isMobile()">
          <v-icon class="orange--text">description</v-icon></v-col
        >
        <v-col cols="12" md="10" class="pr-4"
          ><h4>Zahnarzt Rechnung einreichen</h4>

          <router-link to="/rechnung"
            ><a>Jetzt Rechnung einreichen</a></router-link
          >
        </v-col>
      </v-row>

      <v-row class="mt-2 px-2">
        <v-col cols="12" md="2" v-if="!isMobile()">
          <v-icon class="green--text">security</v-icon></v-col
        >
        <v-col cols="12" md="10" class="pr-4"
          ><h4>Anspruch prüfen</h4>
          <router-link to="/pruefung">
            <a>
              Ihre Versicherung weigert sich vollständig zu bezahlen?
            </a></router-link
          >
        </v-col>
      </v-row>

      <v-row class="mt-2 px-2">
        <v-col cols="12" md="2" v-if="!isMobile()">
          <v-icon>attach_file</v-icon></v-col
        >
        <v-col cols="12" md="10" class="pr-4"
          ><h4>Vertragsunterlagen abrufen</h4>

          <router-link to="/downloads"> <a>jetzt anzeigen</a></router-link>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import baseMixin from "./../../mixins/baseMixin";
  export default {
    mixins: [baseMixin],
    name: "Menue",
    data() {
      return {
        user_id: false,
        user: false,
        tarif: false,
        hinweise: false,
      };
    },
    created() {
      if (this.$store.getters.getUserStore.user_id) {
        this.$log.debug("menue created");
        this.checkLogin();
      }
    },
    watch: {
      // watchuser: function() {
      //   if (!this.$store.getters.getUserStore.user_id) {
      //     this.user_id = false;
      //   } else {
      //     if (this.$store.getters.getUserStore.user_id != this.user_id) {
      //       this.user_id = this.$store.getters.getUserStore.user_id;
      //       this.checkLogin();
      //     }
      //   }
      // },
    },
    computed: {
      // watchuser() {
      //   return this.$store.getters.getUserStore;
      // },
    },
    methods: {
      checkLogin() {
        this.$store.dispatch("checkLogin").then((resp) => {
          this.$log.debug("menue checklogin", resp);
          if (resp.data.user) {
            this.$store.commit("user", resp.data.user);
            this.user = resp.data.user;
            this.tarif = resp.data.tarif;
            this.user_id = resp.data.user_id;
          }
        });
      },
    },
  };
</script>
